import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState } from '../emptyState';
import { SearchEmptyState } from '../searchEmptyState';
import { useModules } from 'src/modules/contentList/hooks/useModules';
import { Loader } from 'src/shared/components/loader';
import { LoadError } from 'src/shared/components/loadError';
import { StringHelper } from 'src/shared/helpers/string';
import { ModuleList } from './moduleList';
export function List({ searchTerm }) {
    const modulesRequest = useModules();
    if (modulesRequest.isLoading) {
        return _jsx(Loader, { full: "screen", "data-testid": "content-list-loader" });
    }
    if (modulesRequest.isError) {
        return _jsx(LoadError, { onTryAgain: modulesRequest.refetch });
    }
    if (!modulesRequest.data?.length) {
        return _jsx(EmptyState, {});
    }
    const filteredModules = modulesRequest.data?.filter((module) => StringHelper.normalizeText(module.name).includes(StringHelper.normalizeText(searchTerm)));
    if (!filteredModules?.length) {
        return _jsx(SearchEmptyState, {});
    }
    return _jsx(ModuleList, { modules: filteredModules });
}
